var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoEndosos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_8",
    "data-name": "Layer 8",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.26 102.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Form_674",
    "data-name": "Form 674",
    className: "cls-1",
    d: "M34.34,100.18c-13.02.05-23.77-10.15-24.41-23.15V23.32C10.62,10.13,21.62-.15,34.83.05h32.44c.5-.07,1.01-.07,1.51,0h.5c1.39,0,2.72.54,3.71,1.51l26.18,25.96c.92.9,1.43,2.13,1.43,3.41v45.09c-.17,13.29-10.93,24.02-24.23,24.16h-42.03ZM20.24,23.43v52.59c0,7.9,6.38,14.31,14.28,14.32h41.63c7.8-.14,14.05-6.48,14.1-14.28v-39.25h-9.1c-9.93.19-18.16-7.66-18.43-17.59v-9.34h-27.9c-7.7-.11-14.11,5.87-14.53,13.56h-.04ZM73.06,19.23c.13,4.37,3.75,7.82,8.12,7.73h3.1l-11.21-11.11v3.38ZM39.03,71.86c-2.72.14-5.03-1.95-5.17-4.66s1.95-5.03,4.66-5.17c.17,0,.34,0,.51,0h27.9c2.72-.14,5.03,1.95,5.17,4.66s-1.95,5.03-4.66,5.17c-.17,0-.34,0-.51,0h-27.9ZM39.03,53.41c-2.72.14-5.03-1.95-5.17-4.66s1.95-5.03,4.66-5.17c.17,0,.34,0,.51,0h17.34c2.72-.14,5.03,1.95,5.17,4.66s-1.95,5.03-4.66,5.17c-.17,0-.34,0-.51,0h-17.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEndosos);
export default __webpack_public_path__ + "static/media/logo_endosos.e1fbbbe4d2a81b06590b0fe74816e439.svg";
export { ForwardRef as ReactComponent };